module.exports = __webpack_public_path__ + "static/presenting-6-f3f498a1fc82540db08f738a82da6aea.jpg";